var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSecurityFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon-Security-Fill",
    transform: "translate(-3)",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Icon",
    d: "M6 6.5a.5.5 0 0 1-1 0V4a4 4 0 0 1 8 0v2.5a.5.5 0 0 1-1 0V4a3 3 0 0 0-6 0zM4.5 16A1.5 1.5 0 0 1 3 14.5v-7A1.5 1.5 0 0 1 4.5 6h9A1.5 1.5 0 0 1 15 7.5v7a1.5 1.5 0 0 1-1.5 1.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurityFill);
export default __webpack_public_path__ + "static/media/icon-security-fill.ad623cda.svg";
export { ForwardRef as ReactComponent };